/** @format */

import './styles.css';
import { Spinner } from 'react-bootstrap';
import keyIcon from '../../assets/img/key.svg';
import emailIcon from '../../assets/img/mobile-alt.svg';
import { Link } from 'react-router-dom';
import {
	getStoredAuthToken,
	storeAuthToken,
} from '../../shared/utils/auth/authToken';
import { useState } from 'react';
import api from '../../shared/utils/auth/Index';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
	faPhoneAlt,
	faShieldAlt,
	faSignInAlt,
	faSyncAlt,
	faUserAlt,
} from '@fortawesome/free-solid-svg-icons';
import AuthLayout from './AuthLayout';
import { useAlert } from 'react-alert';

const Login = () => {
	let reactAlert = useAlert();

	const [mobile, setMobile] = useState('');
	const [password, setPassword] = useState('');

	const [sending, setSending] = useState(false);
	const onSubmit = (e) => {
		e.preventDefault();

		if (mobile.trim().length === 0 || password.length === 0) {
			reactAlert.error('لطفا موبایل و کلمه عبور را وارد کنید.');
			return;
		}

		attemptLogin();
	};

	const attemptLogin = () => {
		setSending(true);

		let URL = '/login ';
		api.post(
			URL,
			{ mobile: mobile, password: password },
			(res) => {
				let data = res.data;

				storeAuthToken(data.token);

				let getUrl = window.location;
				let baseUrl = getUrl.protocol + '//' + getUrl.host;
				window.location.replace(baseUrl);
			},
			(err) => {
				setSending(false);
				reactAlert.error('موبایل یا کلمه عبور اشتباه می باشد.');
			},
		);
	};

	return (
		<AuthLayout>
			<form onSubmit={(e) => onSubmit(e)}>
				<div className='row'>
					<div className='col-auto mx-auto'>
						{/*<img src="/logo.png" alt="Logo" className="img-fluid"/>*/}
					</div>
				</div>

				<div className='row font-irs-b mt-5'>
					<div className='col-auto mx-auto'>
						<div className='row'>
							<div className='col-12 pr-4'>موبایل</div>
						</div>

						<div className='row align-items-center'>
							<div className='col pl-0'>
								<input
									type='text'
									value={mobile}
									onChange={(e) => setMobile(e.target.value)}
									className='auth-input'
								/>
							</div>
							<div className='col-auto px-0'>
								<div className='auth-icon'>
									<img src={emailIcon} className='img-fluid' />
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className='row font-irs-b mt-3'>
					<div className='col-auto mx-auto'>
						<div className='row'>
							<div className='col-12 pr-4'>کلمه عبور</div>
						</div>

						<div className='row align-items-center'>
							<div className='col pl-0'>
								<input
									type='password'
									value={password}
									onChange={(e) => setPassword(e.target.value)}
									className='auth-input'
								/>
							</div>
							<div className='col-auto px-0'>
								<div className='auth-icon'>
									<img src={keyIcon} className='img-fluid' />
								</div>
							</div>
						</div>

						<div className='row align-items-center mt-4'>
							<div className='col-auto pr-4'>
								<Link to='/register' style={{ color: '#A6B2EC' }}>
									ثبت نام
								</Link>
							</div>
							<div className='col-auto mr-auto pl-0'>
								<button className='btn auth-btn font-irs-b'>
									ورود
									{sending && <Spinner animation='border' />}
								</button>
							</div>
						</div>

						<div className='row mt-2'>
							<div className='col-12 text-center'>
								<Link to='/forgot' style={{ color: '#A6B2EC' }}>
									رمز عبور خود را فراموش کرده اید؟
								</Link>
							</div>
						</div>
					</div>
				</div>
			</form>
		</AuthLayout>
	);
};

export default Login;
